import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ICenter } from "@shared/models/center";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";
import { Observable } from "rxjs";

@Injectable()
export class CenterInterceptor implements HttpInterceptor {
    private readonly sessionStorage = inject(SessionStorageService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const storedHealthCenter = this.sessionStorage.getItem(SessionStorageKeys.ScopedCenter);

        if (!storedHealthCenter) return next.handle(req);

        const healthCenter: ICenter = JSON.parse(storedHealthCenter);

        const cloned = req.clone({
            headers: req.headers.set("X-Center-Id", healthCenter.id.toString()),
        });

        return next.handle(cloned);
    }
}
